var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereum2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1227 2021.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:rgba(255,255,255,.5);}.cls-2{fill:rgba(255,255,255,.3);}.cls-3{fill:rgba(255,255,255,.75);}.cls-4{fill:rgba(255,255,255,.15);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "613.5 0 613.5 664.09 194.81 913.09 0 1028.95 613.5 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1227 1028.95 1032.19 913.09 613.5 664.09 613.5 0 1227 1028.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "613.5 1509.67 613.5 2021.57 0 1144.81 613.5 1509.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1227 1144.81 613.5 2021.57 613.5 1509.67 1227 1144.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "613.5 664.09 613.5 1393.81 194.81 1144.81 0 1028.95 194.81 913.09 613.5 664.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1227 1028.95 1032.19 1144.81 613.5 1393.81 613.5 664.09 1032.19 913.09 1227 1028.95"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum2);
export default __webpack_public_path__ + "static/media/ethereum2.332b14e8354f137eefdab8c0b3507939.svg";
export { ForwardRef as ReactComponent };